import { API } from "aws-amplify";

const ROADMAP_URL = "https://roadmap.transloads.co";
const PRODUKTLY_TOKEN_STORAGE_KEY = "produktlyToken";
const EXPIRATION_SAFETY_WINDOW_MS = 30 * 1000;

const decodeJwtPayload = (token) => {
  const payloadBase64 = token?.split(".")?.[1];
  if (!payloadBase64) return null;

  const normalized = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "=",
  );

  const payload = atob(padded);
  return JSON.parse(payload);
};

const getStoredTokenRecord = () => {
  try {
    const raw = localStorage.getItem(PRODUKTLY_TOKEN_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.warn("Unable to parse cached Produktly token", error);
    return null;
  }
};

export const getCachedProduktlyToken = () => {
  const stored = getStoredTokenRecord();
  if (!stored?.token || !stored?.expiresAt) return null;

  if (Date.now() + EXPIRATION_SAFETY_WINDOW_MS >= stored.expiresAt) {
    return null;
  }

  return stored.token;
};

export const setCachedProduktlyToken = (token) => {
  const payload = decodeJwtPayload(token);
  const expSeconds = payload?.exp;
  if (!expSeconds) {
    throw new Error("Produktly token missing exp claim");
  }

  const record = {
    token,
    expiresAt: expSeconds * 1000,
  };

  localStorage.setItem(PRODUKTLY_TOKEN_STORAGE_KEY, JSON.stringify(record));
  return record.token;
};

export const clearCachedProduktlyToken = () => {
  localStorage.removeItem(PRODUKTLY_TOKEN_STORAGE_KEY);
};

export const fetchAndCacheProduktlyToken = async (accessToken) => {
  if (!accessToken) {
    throw new Error("Access token is required");
  }

  const response = await API.post("transREST", "/sign-produktly", {
    body: { token: accessToken },
  });

  if (!response?.produktlyToken) {
    throw new Error("No produktlyToken received");
  }

  return setCachedProduktlyToken(response.produktlyToken);
};

export const ensureProduktlyToken = async (accessToken) => {
  const cached = getCachedProduktlyToken();
  if (cached) return cached;
  return fetchAndCacheProduktlyToken(accessToken);
};

export const buildRoadmapUrl = (token) => {
  if (!token) return ROADMAP_URL;
  return `${ROADMAP_URL}?authToken=${encodeURIComponent(token)}`;
};
